// This file is used for maintain and manage API services
(function () {
  'use strict';
  angular.module('obex').
  factory('organizationProviders', ['$http', '$q', 'obexConstant', 'authService',
    ($http, $q, obexConstant, authService) => {
      return {
        getOrganizationProvidersByOrganizationId(organizationId) {
          const url = obexConstant.urlOrganizationProviders + '/admin/organization/' + organizationId;
          return authService.getAuthorizationHeader().then(authHeader =>
            $http.get(url, {
              headers: authHeader,
            }));
        },
        addOrganizationProviders(organizationProvidersList) {
          const promises = _.map(organizationProvidersList, organizationProvider => {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlOrganizationProviders}`;
              const postData = {
                Id: 0,
                OrganizationId: organizationProvider.OrganizationId,
                ProviderId: organizationProvider.ProviderId
              };
              return $http.post(url, postData, {
                headers: authHeader,
              });
            });
          });
          return $q.all(promises);
        },
        deleteOrganizationProviders(organizationProvidersList) {          
          const promises = _.map(organizationProvidersList, organizationProvider => {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = obexConstant.urlOrganizationProviders + '/' + organizationProvider.Id;              
              return $http.delete(url, {
              headers: authHeader,
            });
            });
          });
          return $q.all(promises);
        },
      };
    },
  ]);
})();



// WEBPACK FOOTER //
// ./client/js/services/organizationProviders.service.js